<mat-accordion class="crm-update-form">
  @for (section of fieldSections(); track section.labelKey) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ section.labelKey | translate }}</mat-panel-title>
      </mat-expansion-panel-header>

      <glxy-form-field>
        <mat-select
          [formControl]="section.group.addControl"
          (selectionChange)="section.group.add($event.value)"
          [disabled]="disableConfigurableGoalFields()"
        >
          <mat-option [value]="null">{{ section.addFieldKey | translate }}</mat-option>
          <mat-option>
            <ngx-mat-select-search
              [placeholderLabel]="'AI_ASSISTANT.SETTINGS.CRM_UPDATE.SEARCH_FIELDS' | translate"
              [noEntriesFoundLabel]="'AI_ASSISTANT.SETTINGS.CRM_UPDATE.NO_FIELDS_FOUND' | translate"
              [formControl]="section.group.searchControl"
            ></ngx-mat-select-search>
          </mat-option>
          @for (schema of section.group.filteredSchemas(); track schema.fieldId) {
            <mat-option [value]="schema">{{ schema.fieldName }}</mat-option>
          }
        </mat-select>
      </glxy-form-field>

      @if (section.group.fields().length === 0) {
        <p>
          {{
            'AI_ASSISTANT.SETTINGS.CRM_UPDATE.NO_FIELDS_SELECTED_DEFAULT'
              | translate: { objectType: (section.objectTypeKey | translate) }
          }}
        </p>
      }

      @for (field of section.group.fields(); track field.fieldId) {
        <div class="field-row">
          <span class="field-name">{{ field.fieldName }}</span>
          <mat-select
            [value]="field.overwrite"
            (selectionChange)="section.group.setOverwrite(field, $event.value)"
            [disabled]="disableConfigurableGoalFields()"
          >
            <mat-option [value]="false">{{
              'AI_ASSISTANT.SETTINGS.CRM_UPDATE.OVERWRITE_IF_EMPTY' | translate
            }}</mat-option>
            <mat-option [value]="true">{{
              'AI_ASSISTANT.SETTINGS.CRM_UPDATE.OVERWRITE_ALWAYS' | translate
            }}</mat-option>
          </mat-select>
          <button
            mat-icon-button
            type="button"
            [attr.aria-label]="'Remove ' + field.fieldName"
            (click)="section.group.remove(field)"
            [disabled]="disableConfigurableGoalFields()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </mat-expansion-panel>
  }

  @if (moreEntitiesEnabled()) {
    @for (s of customObjectSections(); track s.type.customObjectTypeId) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>{{
            'AI_ASSISTANT.SETTINGS.CRM_UPDATE.CUSTOM_OBJECT_FIELDS_LABEL'
              | translate: { name: s.type.singularObjectName }
          }}</mat-panel-title>
        </mat-expansion-panel-header>

        <glxy-form-field>
          <mat-select
            [formControl]="s.group.addControl"
            (selectionChange)="s.group.add($event.value)"
            [disabled]="disableConfigurableGoalFields()"
          >
            <mat-option [value]="null">{{
              'AI_ASSISTANT.SETTINGS.CRM_UPDATE.ADD_CUSTOM_OBJECT_FIELD'
                | translate: { name: s.type.singularObjectName }
            }}</mat-option>
            <mat-option>
              <ngx-mat-select-search
                [placeholderLabel]="'AI_ASSISTANT.SETTINGS.CRM_UPDATE.SEARCH_FIELDS' | translate"
                [noEntriesFoundLabel]="'AI_ASSISTANT.SETTINGS.CRM_UPDATE.NO_FIELDS_FOUND' | translate"
                [formControl]="s.group.searchControl"
              ></ngx-mat-select-search>
            </mat-option>
            @for (schema of s.group.filteredSchemas(); track schema.fieldId) {
              <mat-option [value]="schema">{{ schema.fieldName }}</mat-option>
            }
          </mat-select>
        </glxy-form-field>

        @if (s.group.fields().length === 0) {
          <p>
            {{
              'AI_ASSISTANT.SETTINGS.CRM_UPDATE.NO_FIELDS_SELECTED_REQUIRED'
                | translate: { objectType: s.type.singularObjectName }
            }}
          </p>
        }

        @for (field of s.group.fields(); track field.fieldId) {
          <div class="field-row">
            <span class="field-name">{{ field.fieldName }}</span>
            <mat-select
              [value]="field.overwrite"
              (selectionChange)="s.group.setOverwrite(field, $event.value)"
              [disabled]="disableConfigurableGoalFields()"
            >
              <mat-option [value]="false">{{
                'AI_ASSISTANT.SETTINGS.CRM_UPDATE.OVERWRITE_IF_EMPTY' | translate
              }}</mat-option>
              <mat-option [value]="true">{{
                'AI_ASSISTANT.SETTINGS.CRM_UPDATE.OVERWRITE_ALWAYS' | translate
              }}</mat-option>
            </mat-select>
            <button
              mat-icon-button
              type="button"
              [attr.aria-label]="'Remove ' + field.fieldName"
              (click)="s.group.remove(field)"
              [disabled]="disableConfigurableGoalFields()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </mat-expansion-panel>
    }
  }
</mat-accordion>
